import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  ref: "pageTransitionCurtainEl",
  class: "page-transition-curtain"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_FullscreenLoader = _resolveComponent("FullscreenLoader")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "modal-portal" }, null, -1)),
    (!_ctx.initialLoading)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              onEnter: _ctx.enterTransition,
              onLeave: _ctx.leaveTransition,
              css: false,
              appear: "",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    onRegisterTransitionDelay: _ctx.registerTransitionDelay,
                    key: _ctx.$route.path
                  }, null, 40, ["onRegisterTransitionDelay"]))
                ], 1024))
              ]),
              _: 2
            }, 1032, ["onEnter", "onLeave"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.transitioning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "short-fade" }, {
            default: _withCtx(() => [
              (_ctx.pageLoadPromise)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_Loader)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_FullscreenLoader, {
      loading: _ctx.pageLoading,
      debounced: ""
    }, null, 8, ["loading"])
  ]))
}